import { useCallback, useEffect, useState } from "react";
import useUser, { isUserDoctor, getAuthorized } from "../../../hooks/User";
import { useNavigate } from "react-router-dom";
import ProfileNavigation from "../../../components/common/ProfileNavigation";
import { ROUTES } from "../../../routes";
import config from "../../../Config";
import SEO from "../../../components/SEO";

import "./questions.css";

// Icons
const SearchIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.3-4.3"></path>
    </svg>
);

const PlusIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12h14"></path>
        <path d="M12 5v14"></path>
    </svg>
);

const EditIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"></path>
        <path d="m15 5 4 4"></path>
    </svg>
);

const LockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
    </svg>
);

const GlobeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
        <path d="M2 12h20"></path>
    </svg>
);

const ImageIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
        <circle cx="9" cy="9" r="2"></circle>
        <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
    </svg>
);

const MicIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 19c0 1.7-1.3 3-3 3s-3-1.3-3-3"></path>
        <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
        <line x1="12" x2="12" y1="19" y2="22"></line>
        <rect x="6" y="2" width="12" height="12" rx="6"></rect>
    </svg>
);

const PlayIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="5 3 19 12 5 21 5 3"></polygon>
    </svg>
);

const PauseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="6" y="4" width="4" height="16"></rect>
        <rect x="14" y="4" width="4" height="16"></rect>
    </svg>
);

const XIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
    </svg>
);

const ChevronLeftIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m15 18-6-6 6-6"></path>
    </svg>
);

const ChevronRightIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m9 18 6-6-6-6"></path>
    </svg>
);

const EyeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
        <circle cx="12" cy="12" r="3"></circle>
    </svg>
);

const ListIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"></line>
        <line x1="8" y1="12" x2="21" y2="12"></line>
        <line x1="8" y1="18" x2="21" y2="18"></line>
        <line x1="3" y1="6" x2="3.01" y2="6"></line>
        <line x1="3" y1="12" x2="3.01" y2="12"></line>
        <line x1="3" y1="18" x2="3.01" y2="18"></line>
    </svg>
);

const HashIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="4" y1="9" x2="20" y2="9"></line>
        <line x1="4" y1="15" x2="20" y2="15"></line>
        <line x1="10" y1="3" x2="8" y2="21"></line>
        <line x1="16" y1="3" x2="14" y2="21"></line>
    </svg>
);

const FilterIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
    </svg>
);

const TypeTextIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 7V4h16v3"></path>
        <path d="M9 20h6"></path>
        <path d="M12 4v16"></path>
    </svg>
);

// Audio Player Component
function AudioPlayer({ audioUrl }) {
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const audioRef = useState(new Audio(audioUrl))[0];

    useEffect(() => {
        audioRef.addEventListener('loadedmetadata', () => {
            setDuration(audioRef.duration);
        });
        audioRef.addEventListener('timeupdate', () => {
            setCurrentTime(audioRef.currentTime);
        });
        audioRef.addEventListener('ended', () => {
            setIsPlaying(false);
            setCurrentTime(0);
        });

        return () => {
            audioRef.pause();
            audioRef.src = '';
        };
    }, [audioRef]);

    const togglePlay = () => {
        if (isPlaying) {
            audioRef.pause();
        } else {
            audioRef.play();
        }
        setIsPlaying(!isPlaying);
    };

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };

    const progress = duration ? (currentTime / duration) * 100 : 0;

    return (
        <div className="audio-player">
            <button 
                className="audio-player-btn"
                onClick={togglePlay}
                aria-label={isPlaying ? "Пауза" : "Воспроизвести"}
            >
                {isPlaying ? <PauseIcon /> : <PlayIcon />}
            </button>
            <div className="audio-player-progress">
                <div className="audio-player-bar">
                    <div 
                        className="audio-player-fill" 
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
                <span className="audio-player-time">
                    {formatTime(currentTime)} / {formatTime(duration || 0)}
                </span>
            </div>
        </div>
    );
}

// Question Detail Modal
function QuestionModal({ question, onClose, onEdit, canEdit }) {
    useEffect(() => {
        if (!question) return;
        
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEscape);
        document.body.style.overflow = 'hidden';
        
        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
        };
    }, [onClose, question]);

    if (!question) return null;

    const hasImage = question.picture_filename != null;
    const hasVoice = question.voice_filename != null;
    const isPublic = question.is_public;
    const answerCount = question.answer_options?.length || 0;

    const imageUrl = hasImage 
        ? config.getMediaUrl(question.picture_filename)
        : null;
    const audioUrl = hasVoice 
        ? config.getMediaUrl(question.voice_filename)
        : null;

    return (
        <div className="question-modal-overlay" onClick={onClose}>
            <div className="question-modal" onClick={(e) => e.stopPropagation()}>
                <button className="question-modal-close" onClick={onClose} aria-label="Закрыть">
                    <XIcon />
                </button>

                <div className="question-modal-content">
                    {/* Modal Header with Status and ID */}
                    <div className="question-modal-header">
                        <div className="question-modal-meta">
                            <span className={`question-visibility ${isPublic ? 'public' : 'private'}`}>
                                {isPublic ? <><GlobeIcon /> Публичный</> : <><LockIcon /> Приватный</>}
                            </span>
                            <span className="question-id-badge">
                                <HashIcon />
                                {question.id}
                            </span>
                        </div>
                        {answerCount > 0 && (
                            <span className="question-answers-count">
                                <ListIcon />
                                {answerCount} {answerCount === 1 ? 'вариант' : answerCount < 5 ? 'варианта' : 'вариантов'}
                            </span>
                        )}
                    </div>

                    {/* Image Section */}
                    {hasImage && (
                        <div className="question-modal-image">
                            <img 
                                src={imageUrl} 
                                alt="Изображение к вопросу" 
                                loading="lazy"
                            />
                        </div>
                    )}

                    {/* Question Text */}
                    <div className="question-modal-text">
                        <p>{question.text}</p>
                    </div>

                    {/* Answer Options Preview */}
                    {answerCount > 0 && (
                        <div className="question-modal-answers">
                            <label>Варианты ответа:</label>
                            <ul className="question-answers-list">
                                {question.answer_options.map((option, index) => (
                                    <li key={index} className="question-answer-item">
                                        <span className="question-answer-number">{index + 1}</span>
                                        <span className="question-answer-text">{option}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Audio Section */}
                    {hasVoice && (
                        <div className="question-modal-audio">
                            <label>Голосовое сообщение:</label>
                            <AudioPlayer audioUrl={audioUrl} />
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div className="question-modal-actions">
                        {canEdit && (
                            <button 
                                className="question-modal-btn primary"
                                onClick={() => onEdit(question)}
                            >
                                <EditIcon />
                                Редактировать
                            </button>
                        )}
                        <button 
                            className="question-modal-btn secondary"
                            onClick={onClose}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Question Card Component
function QuestionCard({ question, onEdit, canEdit, onView }) {
    const hasImage = question.picture_filename != null;
    const hasVoice = question.voice_filename != null;
    const isPublic = question.is_public;
    const answerCount = question.answer_options?.length || 0;

    const imageUrl = hasImage 
        ? config.getMediaUrl(question.picture_filename)
        : null;

    const handleImageError = (e) => {
        e.target.style.display = 'none';
        e.target.parentElement.classList.add('image-error');
    };

    return (
        <div className="question-card">
            {/* Image Section */}
            {hasImage && (
                <div className="question-card-image" onClick={() => onView(question)}>
                    <img 
                        src={imageUrl} 
                        alt="" 
                        loading="lazy"
                        onError={handleImageError}
                        crossOrigin="anonymous"
                    />
                    <div className="question-card-image-overlay">
                        <EyeIcon />
                    </div>
                </div>
            )}
            
            <div className="question-card-content">
                {/* Card Header */}
                <div className="question-card-header">
                    <div className="question-card-meta">
                        <span className={`question-visibility ${isPublic ? 'public' : 'private'}`}>
                            {isPublic ? <><GlobeIcon /> Публичный</> : <><LockIcon /> Приватный</>}
                        </span>
                        <span className="question-id-tag">#{question.id}</span>
                    </div>
                    <div className="question-badges">
                        {hasImage && (
                            <span className="question-badge image" title="Есть изображение">
                                <ImageIcon />
                            </span>
                        )}
                        {hasVoice && (
                            <span className="question-badge voice" title="Есть голос">
                                <MicIcon />
                            </span>
                        )}
                    </div>
                </div>
                
                {/* Question Text */}
                <p className="question-text" onClick={() => onView(question)}>{question.text}</p>
                
                {/* Card Stats */}
                <div className="question-card-stats">
                    <span className="question-stat" title="Количество вариантов ответа">
                        <ListIcon />
                        {answerCount}
                    </span>
                </div>
                
                {/* Card Footer */}
                <div className="question-card-footer">
                    <button 
                        className="question-card-btn view"
                        onClick={() => onView(question)}
                    >
                        <EyeIcon />
                        Просмотр
                    </button>
                    {canEdit && (
                        <button 
                            className="question-card-btn edit"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(question);
                            }}
                        >
                            <EditIcon />
                            Изменить
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

// Search Component
function SearchBar({ value, onChange, placeholder = "Поиск по вопросам..." }) {
    return (
        <div className="search-bar">
            <div className="search-icon">
                <SearchIcon />
            </div>
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="search-input"
            />
            {value && (
                <button 
                    className="search-clear"
                    onClick={() => onChange('')}
                    aria-label="Очистить поиск"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 6 6 18"></path>
                        <path d="m6 6 12 12"></path>
                    </svg>
                </button>
            )}
        </div>
    );
}

// Scope Filter Component
function ScopeFilter({ value, onChange }) {
    const options = [
        { value: 'all', label: 'Все', description: 'Мои + публичные' },
        { value: 'my', label: 'Мои', description: 'Только мои вопросы' },
        { value: 'public', label: 'Публичные', description: 'Только публичные' },
    ];

    return (
        <div className="filter-group scope-filter">
            <label className="filter-label">
                <FilterIcon />
                Область видимости
            </label>
            <div className="filter-options scope-options">
                {options.map((option) => (
                    <button
                        key={option.value}
                        className={`filter-btn ${value === option.value ? 'active' : ''}`}
                        onClick={() => onChange(option.value)}
                        title={option.description}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        </div>
    );
}

// Type Filter Component
function TypeFilter({ selectedTypes, onChange }) {
    const options = [
        { value: 'text', label: 'Текст', icon: TypeTextIcon },
        { value: 'voice', label: 'Голос', icon: MicIcon },
        { value: 'picture', label: 'Изображение', icon: ImageIcon },
    ];

    const toggleType = (type) => {
        if (selectedTypes.includes(type)) {
            onChange(selectedTypes.filter(t => t !== type));
        } else {
            onChange([...selectedTypes, type]);
        }
    };

    return (
        <div className="filter-group type-filter">
            <label className="filter-label">Тип вопроса</label>
            <div className="filter-options type-options">
                {options.map((option) => {
                    const Icon = option.icon;
                    const isSelected = selectedTypes.includes(option.value);
                    return (
                        <button
                            key={option.value}
                            className={`filter-btn type-btn ${isSelected ? 'active' : ''}`}
                            onClick={() => toggleType(option.value)}
                        >
                            <Icon />
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

// Pagination Component
function Pagination({ currentPage, totalPages, onPageChange, hasNext, hasPrev }) {
    if (totalPages <= 1) return null;

    const pages = [];
    const maxVisible = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);

    if (endPage - startPage < maxVisible - 1) {
        startPage = Math.max(1, endPage - maxVisible + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
    }

    return (
        <div className="pagination">
            <button 
                className="pagination-btn"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={!hasPrev}
                aria-label="Предыдущая страница"
            >
                <ChevronLeftIcon />
            </button>

            {startPage > 1 && (
                <>
                    <button className="pagination-number" onClick={() => onPageChange(1)}>1</button>
                    {startPage > 2 && <span className="pagination-ellipsis">...</span>}
                </>
            )}

            {pages.map(page => (
                <button
                    key={page}
                    className={`pagination-number ${page === currentPage ? 'active' : ''}`}
                    onClick={() => onPageChange(page)}
                >
                    {page}
                </button>
            ))}

            {endPage < totalPages && (
                <>
                    {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
                    <button className="pagination-number" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
                </>
            )}

            <button 
                className="pagination-btn"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={!hasNext}
                aria-label="Следующая страница"
            >
                <ChevronRightIcon />
            </button>
        </div>
    );
}

// Loading Skeleton
function QuestionSkeleton() {
    return (
        <div className="question-card skeleton">
            <div className="skeleton-image"></div>
            <div className="skeleton-content">
                <div className="skeleton-header"></div>
                <div className="skeleton-text"></div>
                <div className="skeleton-footer"></div>
            </div>
        </div>
    );
}

// Active Filters Display
function ActiveFilters({ scope, types, searchQuery, onClearScope, onClearTypes, onClearSearch }) {
    const hasFilters = scope !== 'all' || types.length > 0 || searchQuery;
    
    if (!hasFilters) return null;

    return (
        <div className="active-filters">
            <span className="active-filters-label">Активные фильтры:</span>
            <div className="active-filters-list">
                {scope !== 'all' && (
                    <span className="active-filter-tag">
                        {scope === 'my' ? 'Мои вопросы' : 'Публичные'}
                        <button onClick={onClearScope} aria-label="Удалить фильтр">
                            <XIcon />
                        </button>
                    </span>
                )}
                {types.map(type => (
                    <span key={type} className="active-filter-tag">
                        {type === 'text' ? 'Текст' : type === 'voice' ? 'Голос' : 'Изображение'}
                        <button onClick={() => onClearTypes(type)} aria-label="Удалить фильтр">
                            <XIcon />
                        </button>
                    </span>
                ))}
                {searchQuery && (
                    <span className="active-filter-tag search-tag">
                        Поиск: "{searchQuery}"
                        <button onClick={onClearSearch} aria-label="Удалить поиск">
                            <XIcon />
                        </button>
                    </span>
                )}
            </div>
        </div>
    );
}

// Main Questions Page
export default function QuestionsPage() {
    const { data, loading: userLoading, error } = useUser();
    const nav = useNavigate();

    const [searchQuery, setSearchQuery] = useState('');
    const [filterScope, setFilterScope] = useState('all');
    const [filterTypes, setFilterTypes] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [returnedCount, setReturnedCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedQuestion, setSelectedQuestion] = useState(null);

    const limit = 9;
    const userIsDoctor = isUserDoctor(data);

    useEffect(() => {
        if (userLoading) return;
        if (error) nav(ROUTES.AUTH, { viewTransition: true });
        if (!userIsDoctor) nav(ROUTES.PROFILE, { viewTransition: true });
    }, [data, userLoading, error, nav, userIsDoctor]);

    const fetchQuestions = useCallback(async (page = 1, query = '', scope = 'all', types = []) => {
        setIsLoading(true);
        setErrorMessage('');

        try {
            const params = {
                st: (page - 1) * limit,
                limit: limit,
            };

            // Add filter_scope if not 'all'
            if (scope && scope !== 'all') {
                params.filter_scope = scope;
            }

            // Add filter_types if any selected
            if (types && types.length > 0) {
                params.filter_types = types;
            }

            // Add search query if present
            if (query.trim()) {
                params.query = query.trim();
            }

            const response = await getAuthorized("/doctor/get_available_questions", { params });

            // New API response format: { questions, total_count, returned_count }
            if (response.data) {
                setQuestions(response.data.questions || []);
                setTotalCount(response.data.total_count || 0);
                setReturnedCount(response.data.returned_count || 0);
            }
        } catch (err) {
            console.error('Failed to fetch questions:', err);
            setErrorMessage('Не удалось загрузить вопросы. Попробуйте позже.');
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!userLoading && userIsDoctor) {
            fetchQuestions(currentPage, searchQuery, filterScope, filterTypes);
        }
    }, [userLoading, userIsDoctor, currentPage, fetchQuestions]);

    // Debounced search effect
    useEffect(() => {
        if (userLoading || !userIsDoctor) return;

        const timer = setTimeout(() => {
            setCurrentPage(1);
            fetchQuestions(1, searchQuery, filterScope, filterTypes);
        }, 300);

        return () => clearTimeout(timer);
    }, [searchQuery, filterScope, filterTypes, userLoading, userIsDoctor, fetchQuestions]);

    const handleCreateQuestion = useCallback(() => {
        nav(ROUTES.QUESTION_EDITOR, { viewTransition: true, state: { questionId: null } });
    }, [nav]);

    const handleEditQuestion = useCallback((question) => {
        setSelectedQuestion(null);
        nav(ROUTES.QUESTION_EDITOR, { 
            viewTransition: true, 
            state: { questionId: question.id } 
        });
    }, [nav]);

    const handleViewQuestion = useCallback((question) => {
        setSelectedQuestion(question);
    }, []);

    const handleCloseModal = useCallback(() => {
        setSelectedQuestion(null);
    }, []);

    const handlePageChange = useCallback((page) => {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const handleClearScope = useCallback(() => {
        setFilterScope('all');
        setCurrentPage(1);
    }, []);

    const handleClearType = useCallback((type) => {
        setFilterTypes(prev => prev.filter(t => t !== type));
        setCurrentPage(1);
    }, []);

    const handleClearSearch = useCallback(() => {
        setSearchQuery('');
        setCurrentPage(1);
    }, []);

    const totalPages = Math.ceil(totalCount / limit);
    const hasNext = currentPage * limit < totalCount;
    const hasPrev = currentPage > 1;

    if (userLoading) {
        return (
            <>
                <ProfileNavigation isDoctor={true} />
                <div className="questions-page">
                    <div className="questions-container">
                        <div className="questions-grid">
                            {[...Array(6)].map((_, i) => <QuestionSkeleton key={i} />)}
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <SEO title="Библиотека вопросов" description="Управление библиотекой вопросов для медицинских опросников" noindex={true} />
            <ProfileNavigation isDoctor={true} />
            <div className="questions-page">
                <div className="questions-container">
                    {/* Header */}
                    <div className="questions-header">
                        <div className="questions-header-content">
                            <h1 className="questions-title">Вопросы</h1>
                            <p className="questions-subtitle">
                                {totalCount > 0 ? `Всего вопросов: ${totalCount}` : 'Управление вопросами для опросов'}
                            </p>
                        </div>
                        <button 
                            className="questions-create-btn"
                            onClick={handleCreateQuestion}
                        >
                            <PlusIcon />
                            Создать вопрос
                        </button>
                    </div>

                    {/* Filters Section */}
                    <div className="questions-filters-section">
                        <div className="filters-row">
                            <ScopeFilter 
                                value={filterScope} 
                                onChange={(value) => {
                                    setFilterScope(value);
                                    setCurrentPage(1);
                                }} 
                            />
                            <TypeFilter 
                                selectedTypes={filterTypes} 
                                onChange={(types) => {
                                    setFilterTypes(types);
                                    setCurrentPage(1);
                                }} 
                            />
                        </div>
                        <div className="search-row">
                            <SearchBar 
                                value={searchQuery}
                                onChange={setSearchQuery}
                                placeholder="Поиск по тексту вопроса..."
                            />
                        </div>
                        <ActiveFilters 
                            scope={filterScope}
                            types={filterTypes}
                            searchQuery={searchQuery}
                            onClearScope={handleClearScope}
                            onClearTypes={handleClearType}
                            onClearSearch={handleClearSearch}
                        />
                    </div>

                    {/* Error Message */}
                    {errorMessage && (
                        <div className="questions-error" role="alert">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="8" x2="12" y2="12"></line>
                                <line x1="12" y1="16" x2="12.01" y2="16"></line>
                            </svg>
                            {errorMessage}
                        </div>
                    )}

                    {/* Results Info */}
                    {!isLoading && (
                        <div className="questions-results-info">
                            <p>
                                {questions.length > 0 ? (
                                    <>Показано <strong>{returnedCount}</strong> из <strong>{totalCount}</strong> вопросов</>
                                ) : (
                                    <>Вопросы не найдены</>
                                )}
                            </p>
                        </div>
                    )}

                    {/* Questions Grid */}
                    {isLoading ? (
                        <div className="questions-grid">
                            {[...Array(6)].map((_, i) => <QuestionSkeleton key={i} />)}
                        </div>
                    ) : questions.length > 0 ? (
                        <div className="questions-grid">
                            {questions.map((question) => (
                                <QuestionCard
                                    key={question.id}
                                    question={question}
                                    onEdit={handleEditQuestion}
                                    canEdit={question.user_id === data?.id}
                                    onView={handleViewQuestion}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="questions-empty">
                            <div className="questions-empty-icon">
                                <SearchIcon />
                            </div>
                            <h3>Вопросы не найдены</h3>
                            <p>
                                {searchQuery || filterScope !== 'all' || filterTypes.length > 0
                                    ? 'Попробуйте изменить параметры фильтрации' 
                                    : 'Создайте первый вопрос, нажав кнопку выше'}
                            </p>
                        </div>
                    )}

                    {/* Pagination */}
                    {!isLoading && totalPages > 1 && (
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                            hasNext={hasNext}
                            hasPrev={hasPrev}
                        />
                    )}
                </div>
            </div>

            {/* Question Detail Modal */}
            {selectedQuestion && (
                <QuestionModal
                    question={selectedQuestion}
                    onClose={handleCloseModal}
                    onEdit={handleEditQuestion}
                    canEdit={selectedQuestion.user_id === data?.id}
                />
            )}
        </>
    );
}
